<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <!-- begin b-card -->
        <b-card no-body>
          <b-card-header
            header-tag="header"
            class="card-header pointer-cursor collapsed"
            aria-expanded="false"
            v-b-toggle.advanceOption
          >
            <i class="fas " :class="isVisible ? 'fa-minus' : 'fa-plus'"></i>
            {{ $t('question.advanceOption') }}
          </b-card-header>
          <b-collapse
            id="advanceOption"
            visible
            accordion="advanceOption"
            v-model="isVisible"
          >
            <b-card-body style="background-color: #f2f3f4;">
              <div class="row">
                <div class="col-sm-6 col-lg-5 col-md-5">
                  <div class="form-group">
                    <label>
                      {{ $t('question.answerOption') }}
                    </label>
                    <select
                      class="form-control"
                      v-model="model.answer_option_id"
                      :disabled="questionType"
                    >
                      <option
                        :value="null"
                        disabled
                        selected
                        style="display: none;"
                      >
                        {{ $t('select') }}
                      </option>
                      <option
                        v-for="(answer, index) in answerOptions"
                        :key="index"
                        :value="answer.answer_option_id"
                      >
                        {{ answer.answer_option }}
                      </option>
                    </select>
                    <div class="validate">
                      {{ errors.first('answer_option_id') }}
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-lg-7 col-md-7">
                  <div class="form-group">
                    <label>
                      {{ $t('question.difficultyLevel') }}
                    </label>
                    <select
                      class="form-control"
                      v-model="model.difficulty_level_id"
                    >
                      <option
                        :value="null"
                        disabled
                        selected
                        style="display: none;"
                      >
                        {{ $t('select') }}
                      </option>
                      <option
                        v-for="(level, index) in difficultyLevels"
                        :key="index"
                        :value="level.difficulty_level_id"
                      >
                        {{ level.difficulty_level }}
                      </option>
                    </select>
                    <div class="validate">
                      {{ errors.first('difficulty_level_id') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-lg-5 col-md-5">
                  <div class="form-group">
                    <label>
                      {{ $t('question.maxScore') }}
                    </label>
                    <input
                      type="number"
                      class="form-control"
                      v-model.number="model.max_score"
                      :placeholder="$t('question.maxScore')"
                      @click="max_score_select"
                      ref="max_score"
                    />
                    <div class="validate">
                      {{ errors.first('max_score') }}
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-lg-7 col-md-7">
                  <div class="form-group">
                    <label>{{ $t('question.penalty') }}</label>
                    <div class="row">
                      <div class="col-sm-6 col-lg-5 col-md-5">
                        <select
                          class="form-control"
                          v-model="model.penalty_type"
                        >
                          <option value="%">
                            %
                          </option>
                          <option value="p">
                            Point
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-6 col-lg-7 col-md-7">
                        <input
                          type="number"
                          class="form-control"
                          v-model.number="model.penalty_rate"
                          :placeholder="$t('question.penaltyRate')"
                          @click="penalty_rate_select"
                          ref="penalty_rate"
                        />
                      </div>
                    </div>
                    <div class="validate">
                      {{ errors.first('penalty_rate') }}
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
        <!-- end b-card -->
      </div>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'advance',
  props: ['value', 'validate'],
  data() {
    return {
      isVisible: true,
      errors: new Errors(),
      model: {},
      loading: true
    }
  },
  created() {
    this.model = this.value
    this.fetchPreData()
  },
  computed: {
    ...mapState('eschool/eExam/question', [
      'answerOptions',
      'difficultyLevels',
      'edit_data'
    ]),
    questionType() {
      if ([4, 5, 6, 7].includes(this.model.question_type_id)) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('eschool/eExam/question', [
      'getAnswerOption',
      'getDifficultyLevel'
    ]),
    async fetchPreData() {
      this.loading = true
      await this.getAnswerOption()
        .then(() => {})
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.getDifficultyLevel()
        .then(() => {
          this.setEdit()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    max_score_select() {
      this.$refs.max_score.select()
    },
    penalty_rate_select() {
      this.$refs.penalty_rate.select()
    },
    setEdit() {
      if (!_.isEmpty(this.edit_data) && this.edit_data !== undefined) {
        this.model.answer_option_id = this.edit_data.answer_option_id
        this.model.difficulty_level_id = this.edit_data.difficulty_level_id
        this.model.max_score = this.edit_data.max_score
        this.model.penalty_rate = this.edit_data.penalty_rate
        this.model.penalty_type = this.edit_data.penalty_type
      }
    }
  }
}
</script>
